import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "QuestionnaireStats";

const keys = addTranslations(RESOURCE_NAME, {
    completion_chart_title: {
        en: "Completion",
        fr: "Complétion",
    },
    completion_chart_title_aiSuggestion: {
        en: "AI Suggested Answers",
        fr: "Réponses suggérées par IA",
    },
    completion_chart_title_questions: {
        en: "Questions",
        fr: "Questions",
    },
    completion_chart_label: {
        en: "Data",
        fr: "Données",
    },
    completion_chart_label_answered: {
        en: "In progress",
        fr: "En cours",
    },
    completion_chart_label_validated: {
        en: "Complete",
        fr: "Terminé",
    },
    completion_chart_label_notAnswered: {
        en: "Not started",
        fr: "Non répondu",
    },
    completion_chart_label_notValidated: {
        en: "Not Completed",
        fr: "Non terminé",
    },
    completion_chart_label_aiSuggestionSuccess: {
        en: "Generated",
        fr: "Généré",
    },
    completion_chart_label_aiSuggestionFailed: {
        en: "Unable to generate",
        fr: "Impossible de générer",
    },
    completion_chart_label_aiSuggestionNotStarted: {
        en: "Not started",
        fr: "Non commencé",
    },
    completion_chart_label_total: {
        en: "{{count}} total",
        fr: "{{count}} total",
    },
    general_info_status: {
        en: "Status",
        fr: "Statut",
    },
    general_info_status_inProgress: {
        en: "In progress",
        fr: "En cours",
    },
    general_info_status_validated: {
        en: "Completed",
        fr: "Terminé",
    },
    general_info_status_todo: {
        en: "Not started",
        fr: "Non commencé",
    },
    general_info_due_date: {
        en: "Due date",
        fr: "Date limite",
    },
    general_info_last_modified: {
        en: "Last modified",
        fr: "Dernière modification",
    },
    user_activity_avatars_label: {
        en: "Assignees",
        fr: "Assignés",
    },
    users_activity_chart_assignee_header: {
        en: "Assignee",
        fr: "Assigné",
    },
    users_activity_chart_completed_assigned_questions_header: {
        en: "Completed assigned questions",
        fr: "Questions assignées terminées",
    },
    users_activity_chart_completed_assigned_questions_total_label: {
        en: "{{completed}} of {{total}}",
        fr: "{{completed}} sur {{total}}",
    },
    users_activity_modal_trigger_button_label: {
        en: "View all {{ count }} assignees",
        fr: "Voir tous les {{ count }} assignés",
    },
    users_activity_modal_title: {
        en: "Assignees and completed assigned questions",
        fr: "Assignés et questions assignées terminées",
    },
    users_activity_modal_close_cta: {
        en: "Close",
        fr: "Fermer",
    },
});

export function useQuestionnaireStatsTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
